import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import {
  ACTIVE_STATUSES,
  PAID_STATUSES,
  DISPLAY_STATUSES,
  INACTIVE_STATUSES,
  APPROVAL,
  INITIATED_BY_USER,
  COMPLETED,
  PAID,
  PRICE_REVIEW
} from "../../constants/statuses"
import { constants } from "caradvise_shared_components"
import { Link } from "react-router-dom"
import { navigationPaths } from "../../constants/paths"
import LoadingThrobber from "../../components/shared/LoadingThrobber"
import {
  orderGridColumnDefs,
  orderGridRowData,
  maintGridColumnDefs,
  mainGridRowData,
  UPCOMING,
  ACTIVE,
  PAST,
  SCHEDULE_BUTTON_FIELD,
  REMIND_ME_BUTTON_FIELD,
  MANUAL_MAINTENANCE_TYPE,
  upcomingIntervalRowData,
  ORDER_ID,
  activeOrderGridColumnDefs
} from "../../constants/services"
import * as agGridHelpers from "../../helpers/agGridHelpers"
import { Button, Checkbox, Image, Menu, Modal, Segment, Popup } from "semantic-ui-react"
import { AgGridReact } from "ag-grid-react"
import debounce from "debounce"
import ServiceSearch from "./ServiceSearch"
import ActiveServicesStats from "./ActiveServicesStats"
import PastServicesStats from "./PastServicesStats"
import UpcomingServiceSummaries from "./UpcomingServiceSummaries"
import ScheduleServiceButton from "../../components/shared/ScheduleServiceButton"
import ScheduleServiceHeader from "../../components/shared/ScheduleServiceHeader"
import * as maintenanceHelpers from "../../helpers/maintenanceHelpers"
import { Date_Format, DatePicker_Format } from "../../constants/years"
import { withTranslation } from "react-i18next"
import {
  isFleetAdvise,
  isFleetMaintenanceHubCanada,
  isMobilease
} from "../../helpers/affiliationHelpers"
import frGrid from "../../locales/fr-ca/grid.json"
import enGrid from "../../locales/en/grid.json"
import { FR_LOCALE } from "../../constants/users"
import CustomNoRowsOverlay from "../shared/CustomNoRowsOverlay"
import { CSVLink } from "react-csv"
import SnoozModal from "../shared/SnoozModal"
import ServiceIndexShimmer from "../../views/services/ServiceIndexShimmer"
import ResetIcon from "../../assets/images/ResetIcon.svg"
import DownloadIcon from "../../assets/images/DownloadIcon.png"
import CustomButton from "../shared/CustomButton"
import ReactTooltip from "react-tooltip"
import ReactSVG from "react-svg"
import { FLEETADVISE_MAINTENANCE_TYPE } from "../../constants/orders"
import moment from "moment"
import { DAY, MONTH } from "../../constants/application"
import { PAGINATION_AMOUNT } from "../../helpers/agGridHelpers"
import CustomNotification from "../shared/CustomNotification"
import { NOTIFICATION_TYPE } from "../../constants/notification"
import { INSPIRATION_MOBILITY } from "../../constants/fleets"
import { APPROVED } from "caradvise_shared_components/lib/constants/orders"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfo } from "@fortawesome/pro-light-svg-icons"
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons"
import { canScheduleService } from "../../helpers/userRoleHelpers"

const { AWAITING_APPROVAL } = constants.orders
const DUE_FILTER_ALL = "all"
const DUE_FILTER_DUE_SOON = "dueSoon"
const DUE_FILTER_PAST_DUE = "pastDue"

class ServiceList extends Component {
  constructor(props) {
    super(props)
    this.debouncedOnQuickFilterChange = this.onQuickFilterChange
    this.debouncedOnSizeToFitChange = debounce(this.onSizeToFitChange, 100)

    const locationStateData = this.props?.location?.state || {}
    let startingDate = locationStateData.startingDate
      ? moment(locationStateData.startingDate, "YYYY-MM-DD HH:mm:ss Z").add(1, DAY) // Shitty hack to account for UTC being off-one-day for the continental US
      : moment().subtract(2, MONTH)
    // sometimes shitty hack makes us go to day 2, subtract.
    if (startingDate.date() == 2) startingDate = startingDate.subtract(1, DAY)
    this.state = {
      dueFilter: DUE_FILTER_ALL,
      activePage: ACTIVE,
      orderFilter: this.props.orderFilter ?? [AWAITING_APPROVAL],
      sizeToFit: false,
      showGrid: true,
      filteredItems: [],
      openSnoozModal: false,
      vehicleId: null,
      selectedValue: "Remind Me",
      search_text: "",
      pages: [
        {
          name: UPCOMING,
          label: "upcomingIntervalsLabel",
          filter: (orders, vehicles) =>
            maintenanceHelpers.upcomingIntervalServices({
              vehicles,
              serviceSchedulesByVehicle: this.props.serviceSchedulesByVehicle
            }),
          rowData: mainGridRowData,
          columnDefs: maintGridColumnDefs
        },
        {
          name: ACTIVE,
          label: "activeOrdersLabel",
          filter: (orders) => orders,
          rowData: orderGridRowData,
          columnDefs: activeOrderGridColumnDefs
        },
        {
          name: PAST,
          label: "pastOrdersLabel",
          filter: (orders) =>
            orders
              .filter((o) => PAID_STATUSES.indexOf(o?.status) !== -1)
              .sort((a, b) =>
                Date.parse(a.appointment_datetime) > Date.parse(b.appointment_datetime) ? -1 : 1
              ),
          rowData: orderGridRowData,
          columnDefs: orderGridColumnDefs
        }
      ],
      resetFilteringCallback: null,
      activeEndDate: moment(startingDate).add(3, MONTH).endOf(DAY),
      activeStartDate: moment(startingDate)
    }
  }

  static propTypes = {
    shopOrders: PropTypes.array.isRequired,
    pastOrderDateChange: PropTypes.func,
    activeOrderDateChange: PropTypes.func
  }

  servicesCellRenderer = (cellParams) => {
    const services = cellParams.value
    return (
      <Modal size="mini" trigger={<span>{services}</span>}>
        <Modal.Content>{services}</Modal.Content>
      </Modal>
    )
  }

  schedulerCellRenderer = (cellParams) => {
    if (cellParams && cellParams.value) {
      const { maintenance, vehicle } = cellParams.value

      return <ScheduleServiceButton secondary vehicle={vehicle} maintenance={maintenance} />
    }
  }

  closeSnoozModal = () => {
    this.setState({ openSnoozModal: false })
  }

  handleRemindClick = (vehicleId) => {
    this.setState({ openSnoozModal: true, vehicleId })
  }

  reminderCellRenderer = (cellParams) => {
    if (cellParams && cellParams.value) {
      const { vehicle } = cellParams.value

      return (
        <React.Fragment>
          <Button onClick={() => this.handleRemindClick(vehicle.id)} secondary>
            {this.props.t("common:remindMeLabel")}
          </Button>
        </React.Fragment>
      )
    }
  }

  statusCellRenderer = (cellParams, t) => {
    if (cellParams && cellParams.value) {
      const { status, id } = cellParams.value
      if (status !== AWAITING_APPROVAL) {
        return t(DISPLAY_STATUSES[status])
      } else {
        return (
          <Link to={navigationPaths.approvalsShow(id, status)}>
            <Button>{t("reviewLabel")}</Button>
          </Link>
        )
      }
    }
  }

  downloadInvoiceRenderer = (cellParams, t) => {
    return (
      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <span>{cellParams.value}</span>
        {cellParams.data &&
          cellParams.data.maintenance_type === FLEETADVISE_MAINTENANCE_TYPE &&
          [COMPLETED, PAID].includes(cellParams.data.status.status) && (
            <Popup
              content="View Receipt"
              inverted
              position="right center"
              trigger={
                <div
                  data-for={"view-invoice-" + cellParams.value}
                  data-tip
                  style={{ cursor: "pointer" }}
                >
                  <ReactSVG
                    src={"/assets/icons/eye.svg"}
                    onClick={() => {
                      window.open(`/orders/${cellParams.value}/approvals/invoice`, "_blank")
                    }}
                  />
                </div>
              }
            />
          )}
      </div>
    )
  }

  viewOrder = (cell) => {
    if (
      cell.colDef.field !== SCHEDULE_BUTTON_FIELD &&
      cell.colDef.field !== REMIND_ME_BUTTON_FIELD &&
      cell.colDef.field !== ORDER_ID
    ) {
      // cell.data.status being null or not differentiates ShopOrder vs Vehicle
      if (cell.data.status == null) {
        const path = navigationPaths.vehicleShow
        this.props.history.push(path(cell.data.id))
      } else if (cell.data.maintenance_type === MANUAL_MAINTENANCE_TYPE) {
        const path = navigationPaths.vehicleShow
        this.props.history.push(path(cell.data.vehicle_id))
      } else {
        const path = navigationPaths.approvalsShow
        this.props.history.push(path(cell.data.id, cell.data.status.status))
      }
    }
  }

  noRowsTemplate() {
    return `<span> ${this.props.t("noOrdersInFleet")} </span>`
  }

  handleChangeStart = (date, isActivePage) => {
    const { pastOrderDateChange } = this.props
    const normalizedDate = moment(date).startOf("day")

    isActivePage
      ? this.setState({ activeStartDate: normalizedDate }, this.loadActiveOrders)
      : pastOrderDateChange(normalizedDate, "pastStartDate")
  }

  handleChangeEnd = (date, isActivePage) => {
    const { pastOrderDateChange } = this.props
    const normalizedDate = moment(date).startOf("day")
    isActivePage
      ? this.setState({ activeEndDate: normalizedDate }, this.loadActiveOrders)
      : pastOrderDateChange(normalizedDate, "pastEndDate")
  }

  async componentDidMount() {
    if (this.state.activePage === UPCOMING) {
      this.handlePageChange(UPCOMING)
    }
  }

  handlePageChange = async (page) => {
    this.saveFilterModel()
    await this.setState({ activePage: page })
    this.restorePageFilterModel()
    this.setFilteredItems()
    if (this.state.sizeToFit) {
      this.api && this.api.sizeColumnsToFit()
    }
    const { shopOrders, manualMaintenanceHistories, serviceSchedulesByVehicle } = this.props
    if (
      page == PAST &&
      ((shopOrders && shopOrders.length == 0) ||
        (manualMaintenanceHistories && manualMaintenanceHistories.length == 0))
    ) {
      this.pastShopOrders()
      this.setFilteredItems()
    }
    if (page == UPCOMING && Object.keys(serviceSchedulesByVehicle).length === 0) {
      const { vehicles, dispatch } = this.props
      this.props.refreshMaintenanceIntervals()
      if (vehicles.length) {
        dispatch({
          type: "MAINTENANCE_REMINDER_SNOOZED_DATE_SAGA",
          payload: { vehicleIds: vehicles.map((vehicle) => vehicle.id) }
        })
      }
    }
  }

  pastShopOrders = () => {
    const { loadPastShopOrders, pastStartDate, pastEndDate } = this.props
    loadPastShopOrders(pastStartDate, pastEndDate, { skipUnsetLoading: true })
  }

  // Note getDataAsCSV on api allows for downloading as CSV.
  onGridReady = (params) => {
    this.api = params.api
    this.columnApi = params.columnApi
    if (this.state.sizeToFit) params.api.sizeColumnsToFit()
    this.setFilteredItems()
    window.addEventListener(
      "resize",
      () => this.state.sizeToFit && this.api && this.api.sizeColumnsToFit()
    )
  }

  onActiveOrdersGridReady = (params) => {
    const { sizeToFit } = this.state
    this.api = params.api
    this.columnApi = params.columnApi
    if (sizeToFit) params.api.sizeColumnsToFit()
    window.addEventListener("resize", () => sizeToFit && this.api.sizeColumnsToFit())
    this.loadActiveOrders()
  }

  onQuickFilterChange = (_, event) => {
    this.setState({ quickFilterText: (event && event.value) || "" })
  }

  saveFilterModel = () => {
    const oldFilter = this.state.filterModels || {}
    oldFilter[this.state.activePage] = this.api && this.api.getFilterModel()
    this.setState({ filterModels: oldFilter })
  }

  restorePageFilterModel = () =>
    this.api && this.api.setFilterModel(this.state.filterModels[this.state.activePage])

  setFilteredItems = () =>
    this.setState({
      filteredItems: this.api && this.api.getModel()?.rowsToDisplay?.map((r) => r.data)
    })

  resetFiltering = () => {
    this.api && this.api.setFilterModel([])
    this.setState({ orderFilter: null, quickFilterText: "" })
    this.onQuickFilterChange()
    this.state.resetFilteringCallback()
  }

  onSizeToFitChange = (event, syntheticEvent) => {
    this.setState({ sizeToFit: syntheticEvent.checked })
    if (syntheticEvent.checked) {
      this.api && this.api.sizeColumnsToFit()
    } else this.redrawGrid()
  }

  redrawGrid() {
    this.setState({ showGrid: false })
    setTimeout(() => this.setState({ showGrid: true }), 500)
  }

  externalFilterChanged = (newValue) => {
    this.setState({ dueFilter: newValue }, () => this.api && this.api.onFilterChanged())
  }

  isExternalFilterPresent = () => {
    // if dueFilter is not DUE_FILTER_ALL, then we are filtering
    return this.state.dueFilter != DUE_FILTER_ALL
  }

  doesExternalFilterPass = (node) => {
    const dueFilter = this.state.dueFilter
    switch (dueFilter) {
      case DUE_FILTER_DUE_SOON:
        return node.data.due_status === maintenanceHelpers.DUE_SOON
      case DUE_FILTER_PAST_DUE:
        return node.data.due_status === maintenanceHelpers.PAST_DUE
      default:
        return true
    }
  }

  customGridOptions = () => {
    return {
      onFilterChanged: this.setFilteredItems,
      onCellClicked: this.viewOrder,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass
    }
  }

  downloadOrders = (isActivePage) => {
    const { pastStartDate, pastEndDate, dispatch } = this.props
    const { activeEndDate, activeStartDate } = this.state
    isActivePage
      ? dispatch({
          type: "SHOP_ORDERS_DOWNLOAD_SAGA",
          payload: { startDate: activeStartDate, endDate: activeEndDate, isActivePage }
        })
      : dispatch({
          type: "SHOP_ORDERS_DOWNLOAD_SAGA",
          payload: { startDate: pastStartDate, endDate: pastEndDate, isActivePage }
        })
  }

  renderUpcomingServiceSummaries = (vehicles, t) => {
    return (
      <UpcomingServiceSummaries
        serviceSchedulesByVehicle={this.props.serviceSchedulesByVehicle}
        onClickPastDue={this.externalFilterChanged.bind(this, DUE_FILTER_PAST_DUE)}
        onClickDueSoon={this.externalFilterChanged.bind(this, DUE_FILTER_DUE_SOON)}
        onClickAll={() => this.externalFilterChanged(DUE_FILTER_ALL)}
        vehicles={vehicles}
      />
    )
  }

  handlechange = (e, orderType, setOrderStatuses, value) => {
    const { orderFilter } = this.state

    if (value.checked) {
      if (orderFilter == null) {
        this.setState({ orderFilter: orderType })
      } else {
        this.setState({ orderFilter: orderFilter.concat(orderType) })
      }
    } else {
      let temp = orderFilter

      orderType.forEach((e) => {
        temp?.splice(temp.indexOf(e), 1)
      })

      if (temp.length != 0) {
        this.setState({ orderFilter: temp })
      } else {
        this.setState({ orderFilter: null })
      }
    }

    if (orderType.includes(INITIATED_BY_USER, ACTIVE, PRICE_REVIEW)) {
      setOrderStatuses((prev) => ({
        ...prev,
        isActiveOrderChecked: value.checked
      }))
    } else if (orderType.includes(AWAITING_APPROVAL)) {
      setOrderStatuses((prev) => ({
        ...prev,
        isApprovalOrderChecked: value.checked
      }))
    } else if (orderType.includes(APPROVAL)) {
      setOrderStatuses((prev) => ({
        ...prev,
        isApprovedOrderChecked: value.checked
      }))
    }

    if (this.state.activePage === ACTIVE) {
      setTimeout(() => this.loadActiveOrders(), 0)
    }
  }

  handleResetFilterCallback = (callback) => {
    this.setState({ resetFilteringCallback: callback })
  }

  goToFirstPage = () => {
    const currentPage = this.state.page

    if (currentPage !== 1) {
      this.handlePageChange({ newPage: 1 })
    }
  }

  goToPreviousPage = () => {
    const currentPage = this.state.page
    if (currentPage > 1) {
      this.handleActiveOrderPageChange({ newPage: currentPage - 1 })
    }
  }

  goToNextPage = () => {
    const currentPage = this.state.page
    if (currentPage < this.props.totalPages) {
      this.handleActiveOrderPageChange({ newPage: currentPage + 1 })
    }
  }

  goToLastPage = () => {
    const totalPage = this.props.totalPages
    const currentPage = this.state.page

    if (currentPage !== totalPage) {
      this.handleActiveOrderPageChange({ newPage: totalPage })
    }
  }

  onSortChanged = () => {
    const sortModel = this.api.getSortModel()
    this.setState({ sortModel })

    this.handleActiveOrderPageChange({ newPage: 1 })
  }

  handleActiveOrderPageChange = async ({ newPage }) => {
    if (newPage) {
      this.api.showLoadingOverlay()
      this.loadActiveOrders({
        page: newPage
      })
    }
  }

  loadActiveOrders = async (payload) => {
    setTimeout(() => {
      this?.api?.showLoadingOverlay()
    })

    if (!payload) {
      payload = {}
    }

    if (!payload?.page) {
      payload.page = 1
    }

    function removeSuffix(str) {
      return str?.replace(/_1$/, "")
    }

    await this.props.dispatch({
      type: "SHOP_ORDERS_LOAD_SAGA",
      payload: {
        options: {
          startDate: this.state.activeStartDate?.format(Date_Format.YYYY_MM_DD),
          endDate: this.state.activeEndDate?.format(Date_Format.YYYY_MM_DD),
          captureActive: true,
          withMaintenanceHistory: false,
          state_id: this.state.orderFilter,
          sort_by: removeSuffix(this.state.sortModel?.[0]?.colId) ?? null,
          direction: this.state.sortModel?.[0]?.sort ?? null,
          query: this.state.search_text,
          search_type: this.state.selectedOption,
          ...payload
        },
        skipUnsetLoading: true
      },
      callback: () => {
        this.setState({
          isActiveOrderLoading: false,
          loading: false
        })
        this.afterLoadActiveShopOrders()
      }
    })
    this.setState({ page: payload.page })
  }

  afterLoadActiveShopOrders = () => {
    const { activeShopOrders } = this.props
    if (!activeShopOrders || activeShopOrders.length === 0) {
      this.api.showNoRowsOverlay()
    } else {
      this.api.hideOverlay()
    }

    if (this.state.sortModel?.length) {
      this.columnApi.applyColumnState({
        state: this.state.sortModel?.map((s) => ({
          colId: s.colId,
          sort: s.sort
        })),
        defaultState: { sort: null }
      })
    }
  }

  onTextChange = (event) => {
    this.setState({ search_text: event.target.value })

    if (event.target.value === "") {
      this.api.showLoadingOverlay()
      this.setState({ search_text: "", showDropdown: false }, this.loadActiveOrders)
    }
  }

  onOptionChange = (e) => {
    this.setState({ selectedOption: e.target.value })
  }

  onSearch = () => {
    const { t } = this.props
    const { search_text, selectedOption } = this.state
    if (search_text !== "" && search_text.length >= 3) {
      this.api.showLoadingOverlay()
      this.loadActiveOrders()
    } else {
      return CustomNotification(NOTIFICATION_TYPE.DANGER, "", t("invalidSearchValue"), t)
    }
  }

  render() {
    const {
      shopOrders,
      vehicles,
      language,
      t,
      pastStartDate,
      pastEndDate,
      activeShopOrders,
      dispatch,
      vehicleReminders,
      isPastOrderLoading,
      currentUser
    } = this.props
    const {
      pages,
      activePage,
      filteredItems,
      sizeToFit,
      showGrid,
      openSnoozModal,
      vehicleId,
      orderFilter,
      activeStartDate,
      activeEndDate
    } = this.state
    const page = pages?.find((p) => p.name === activePage)
    const isActivePage = activePage === ACTIVE
    const isPastPage = activePage === PAST
    const isUpcomingPage = activePage === UPCOMING
    const items =
      page && page.filter.call(this, isActivePage ? activeShopOrders : shopOrders, vehicles)
    const upcomingIntervals = isUpcomingPage ? upcomingIntervalRowData(items, t) : null

    let filteredPages =
      this.props.currentUser?.affiliation_name === INSPIRATION_MOBILITY
        ? pages.filter((page) => page.name !== UPCOMING)
        : pages

    return (
      <div>
        <span />
        {canScheduleService(currentUser) && (
          <ScheduleServiceHeader header={t("dashboard:shopOrdersLabel")} />
        )}
        <Segment.Group>
          <Segment className="menu-container">
            <Menu pointing secondary stackable>
              {filteredPages.map((page) => (
                <Menu.Item
                  key={page.name}
                  name={t(page.label)}
                  active={page.name === activePage}
                  onClick={() => this.handlePageChange(page.name)}
                  className={isFleetAdvise() || isMobilease() ? "menu-theme-color font-weight" : ""}
                />
              ))}

              {(activePage === PAST || isActivePage) && (
                <Menu.Item position="right" className="right-section-option skinny-menu-button">
                  <div className="service-daterange">
                    <p className="date-filter-label">{t("appointment")}</p>

                    <div className="service-datepicker">
                      {t("fromLabel")}:
                      <DatePicker
                        selected={isActivePage ? activeStartDate : pastStartDate}
                        selectsStart
                        dateFormat={
                          isFleetMaintenanceHubCanada()
                            ? DatePicker_Format.YYYY_MM_DD
                            : DatePicker_Format.MM_DD_YYYY
                        }
                        pastEndDate={isActivePage ? activeEndDate : pastEndDate}
                        onChange={(date) => this.handleChangeStart(date, isActivePage)}
                      />
                    </div>

                    <div className="service-datepicker">
                      {t("toLabel")}:
                      <DatePicker
                        selected={isActivePage ? activeEndDate.toDate() : pastEndDate.toDate()}
                        selectsEnd
                        dateFormat={
                          isFleetMaintenanceHubCanada()
                            ? DatePicker_Format.YYYY_MM_DD
                            : DatePicker_Format.MM_DD_YYYY
                        }
                        pastStartDate={isActivePage ? activeStartDate : pastStartDate}
                        onChange={(date) => this.handleChangeEnd(date, isActivePage)}
                      />
                    </div>

                    <Button onClick={this.resetFiltering} className="white-button">
                      {(isFleetAdvise() || isMobilease()) && (
                        <Image src={ResetIcon} className="vehicle-icons" />
                      )}
                      {t("resetFiltersLabel")}
                    </Button>

                    {activePage === PAST ? (
                      <CustomButton
                        className="download-button"
                        onClick={() => this.downloadOrders(isActivePage)}
                        disabled={!items?.length}
                        iconSrc={DownloadIcon}
                        iconClassName="vehicle-icons"
                        label={t("downloadLabel")}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </Menu.Item>
              )}

              {isUpcomingPage && (
                <Menu.Item position="right" className="right-section-option skinny-menu-button">
                  <Button onClick={this.resetFiltering} className="white-button">
                    {(isFleetAdvise() || isMobilease()) && (
                      <Image src={ResetIcon} className="vehicle-icons" />
                    )}
                    {t("resetFiltersLabel")}
                  </Button>

                  {upcomingIntervals?.length ? (
                    <CSVLink
                      data={upcomingIntervals}
                      filename="Upcoming Intervals Report.csv"
                      className="ui button download-button"
                      separator=","
                    >
                      <div className="download-icon">
                        <Image src={DownloadIcon} className="vehicle-icons" />
                        {t("downloadLabel")}
                      </div>
                    </CSVLink>
                  ) : (
                    <Button disabled className="download-text">
                      <div className="download-icon">
                        <Image src={DownloadIcon} className="vehicle-icons" />
                        {t("downloadLabel")}
                      </div>
                    </Button>
                  )}
                </Menu.Item>
              )}
            </Menu>
          </Segment>

          <Segment style={{ border: "none" }}>
            <ServiceSearch
              debouncedOnFilterChange={this.debouncedOnQuickFilterChange}
              resetFiltering={this.resetFiltering}
              orderFilter={orderFilter}
              isActivePage={isActivePage}
              handlechange={this.handlechange}
              handleResetFilterCallback={this.handleResetFilterCallback}
              fieldValue={this.state.quickFilterText}
              onTextChange={this.onTextChange}
              onOptionChange={this.onOptionChange}
              selectedOption={this.state.selectedOption}
              searchText={this.state.search_text}
              onSearch={this.onSearch}
            />

            {page.name === UPCOMING && this.renderUpcomingServiceSummaries(vehicles, t)}

            {page.name === ACTIVE && (
              <ActiveServicesStats
                orders={activeShopOrders?.filter((o) => !INACTIVE_STATUSES.includes(o.status))}
              />
            )}

            {page.name === PAST && (
              <PastServicesStats agGridFormattedOrders={filteredItems ?? []} />
            )}
          </Segment>

          <Segment
            className={`ag-theme-material tab-container${sizeToFit ? "" : " wrap-headers"}`}
            style={{
              height: agGridHelpers.dynamicGridHeight({ items })
            }}
          >
            <Checkbox
              label={t("sizeToFitLabel")}
              onChange={this.debouncedOnSizeToFitChange}
              checked={sizeToFit}
            />

            {(isUpcomingPage && this.props.loading) ||
            (isPastPage && isPastOrderLoading) ||
            (isActivePage && this.props.isActiveOrderLoading) ? (
              <ServiceIndexShimmer only_grid />
            ) : showGrid ? (
              <AgGridReact
                columnDefs={page.columnDefs
                  .call(
                    this,
                    activePage,
                    this.servicesCellRenderer,
                    this.schedulerCellRenderer,
                    (params) => this.statusCellRenderer(params, t),
                    this.reminderCellRenderer,
                    t,
                    this.downloadInvoiceRenderer
                  )
                  .map((col) => ({
                    ...col,
                    headerTooltip: col.headerName
                  }))}
                defaultColDef={{
                  sortable: true,
                  filter: page.name !== ACTIVE,
                  ...(page.name === ACTIVE && {
                    comparator: () => 0
                  }),
                  tooltipValueGetter: (params) => params.value
                }}
                localeText={language === FR_LOCALE ? frGrid : enGrid}
                rowData={page.rowData.call(
                  this,
                  page.name === ACTIVE ? activeShopOrders : items,
                  language,
                  vehicleReminders
                )}
                rowSelection="single"
                onGridReady={page.name === ACTIVE ? this.onActiveOrdersGridReady : this.onGridReady}
                onCellClicked={page.name === ACTIVE ? this.viewOrder : undefined}
                onSortChanged={page.name === ACTIVE ? this.onSortChanged : undefined}
                gridOptions={
                  page.name === ACTIVE
                    ? { onFilterChanged: this.setFilteredItems }
                    : this.customGridOptions()
                }
                frameworkComponents={{
                  customNoRowsOverlay: CustomNoRowsOverlay
                }}
                noRowsOverlayComponent="customNoRowsOverlay"
                noRowsOverlayComponentParams={{
                  translationFile: "services",
                  label: "noOrdersInFleet"
                }}
                headerHeight={sizeToFit ? undefined : 80}
                quickFilterText={this.state.quickFilterText}
                cacheQuickFilter
                pagination={page.name !== ACTIVE}
                paginationPageSize={agGridHelpers.PAGINATION_AMOUNT}
                suppressMenuHide
                suppressMovableColumns={false}
                suppressCellSelection
              />
            ) : (
              <LoadingThrobber visible />
            )}

            {openSnoozModal && (
              <SnoozModal
                vehicleId={vehicleId}
                dispatch={dispatch}
                selectedValue={this.state.selectedValue}
                openSnoozModal={openSnoozModal}
                closeSnoozModal={this.closeSnoozModal}
                vehicles={vehicles}
                t={t}
              />
            )}

            {page.name === ACTIVE && (
              <div className="ag-paging-panel ag-unselectable">
                <span className="ag-paging-row-summary-panel">
                  {(this.state.page - 1 || 0) * PAGINATION_AMOUNT + 1} to{" "}
                  {Math.min(
                    ((this.state.page - 1 || 0) + 1) * PAGINATION_AMOUNT,
                    this.props.totalOrdersCount
                  )}{" "}
                  of {this.props.totalOrdersCount}
                </span>

                <span className="ag-paging-page-summary-panel">
                  <div className="ag-paging-button" onClick={this.goToFirstPage}>
                    <span className="ag-icon ag-icon-first" />
                  </div>
                  <div className="ag-paging-button" onClick={this.goToPreviousPage}>
                    <span className="ag-icon ag-icon-previous" />
                  </div>

                  <span className="ag-paging-description">
                    Page <span>{this.state.page}</span> of <span>{this.props.totalPages}</span>
                  </span>

                  <div className="ag-paging-button" onClick={this.goToNextPage}>
                    <span className="ag-icon ag-icon-next" />
                  </div>
                  <div className="ag-paging-button" onClick={this.goToLastPage}>
                    <span className="ag-icon ag-icon-last" />
                  </div>
                </span>
              </div>
            )}
          </Segment>
        </Segment.Group>
      </div>
    )
  }
} // class ServiceList

const mapStateToProps = (state) => {
  return {
    loading: state.maintenanceIntervals.loading,
    activeShopOrders: state.shopOrders.activeShopOrders?.orders ?? [],
    totalPages: state.shopOrders.activeShopOrders?.total_pages,
    totalOrdersCount: state.shopOrders.activeShopOrders?.total_orders_count,
    currentUser: state.application.userSessionData || state.users.currentUser
  }
}

export default connect(mapStateToProps)(withTranslation("services")(ServiceList))
